import { useEffect, useRef } from "react";
import { pushCleverTapEvent } from "@/component/shared/pushCleverTapEvent";

export default function ScrollTraking() {
  const scrollEventsFired = useRef({
    scroll25: false,
    scroll50: false,
    scroll75: false,
  });

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolledPercent = (scrollTop / docHeight) * 100;

      if (scrolledPercent >= 25 && !scrollEventsFired.current.scroll25) {
        pushCleverTapEvent("HomVFage_Scroll_25%", { PageName: "HomePage" });
        scrollEventsFired.current.scroll25 = true;
      }

      if (scrolledPercent >= 50 && !scrollEventsFired.current.scroll50) {
        pushCleverTapEvent("HomVFage_Scroll_50%", { PageName: "HomePage" });
        scrollEventsFired.current.scroll50 = true;
      }

      if (scrolledPercent >= 75 && !scrollEventsFired.current.scroll75) {
        pushCleverTapEvent("HomVFage_Scroll_75%", { PageName: "HomePage" });
        scrollEventsFired.current.scroll75 = true;
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  return null;
}
